<template>
  <aside class="c-fathom-affiliate-banner p-4 text-1 beta:text-2 rounded-md">
    <p class="m-0 leading-normal">
      Simple, unobtrusive, privacy-minded analytics (<span class="font-medium"
        >$10 free credit</span
      >) –

      <viewsource-link
        href="https://usefathom.com/ref/FO6560"
        class="c-fathom-affiliate-banner__link inline-block py-1 beta:py-0 font-bold"
      >
        Fathom Analytics

        <fathom-analytics-logo
          class="c-fathom-affiliate-banner__logo"
          width="16"
          height="16"
          role="img"
          aria-label="Fathom Analytics Logo"
        />
      </viewsource-link>
    </p>
  </aside>
</template>

<script>
import FathomAnalyticsLogo from '~/assets/img/fathom-analytics-logo.svg';
import ViewsourceLink from '~/components/ViewsourceLink.vue';

export default {
  components: {
    FathomAnalyticsLogo,
    ViewsourceLink,
  },
};
</script>

<style lang="postcss">
.c-fathom-affiliate-banner {
  @media (prefers-color-scheme: dark) {
    background-color: var(--color-tuna);
  }

  @nest .t-light & {
    background-color: var(--color-white-smoke);
  }

  @nest .t-dark & {
    background-color: var(--color-tuna);
  }
}

.c-fathom-affiliate-banner__logo {
  transform: translateY(1px);
}
</style>
